import { AddQuestionsForAdvocateMeta, AddQuestionsForAdvocatePayload } from 'types/store/AddQuestionsForAdvocate';
import { createAsyncReducer } from 'utils/Redux';

import { addQuestionsForAdvocateActions } from '../actions';

export default createAsyncReducer<AddQuestionsForAdvocateMeta, AddQuestionsForAdvocatePayload>(addQuestionsForAdvocateActions);
